/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Instance = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MissingActionException = require('./Exception/MissingActionException');

var _Action = require('./Action');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Resource instance
 */
let Instance = exports.Instance = function () {
  /**
   * @param {String} name
   * @param {Object} microservice
   */
  function Instance(name, microservice) {
    _classCallCheck(this, Instance);

    this._name = name;
    this._microservice = microservice;
    this._rawActions = microservice.rawResources[name];
    this._actions = null;
    this._localBackend = false;
    this._isBackend = false;
    this._cache = null;
    this._security = null;
    this._validation = null;
    this._contextProvider = null;
    this._log = null;
    this._baseUrl = null;

    this._fillActions();
  }

  /**
   * @param {String} url
   */


  _createClass(Instance, [{
    key: '_fillActions',


    /**
     * @private
     */
    value: function _fillActions() {
      this._actions = {};

      for (let actionName in this._rawActions) {
        if (!this._rawActions.hasOwnProperty(actionName)) {
          continue;
        }

        let actionMetadata = this._rawActions[actionName];

        let actionInstance = new _Action.Action(this, actionName, actionMetadata.type, actionMetadata.methods, actionMetadata.source, actionMetadata.region, actionMetadata.forceUserIdentity, actionMetadata.apiCache, actionMetadata.scope, actionMetadata.api);

        if (actionMetadata.validationSchema) {
          actionInstance.validationSchemaName = actionMetadata.validationSchema;
        }

        actionInstance.baseUrl = this._baseUrl;

        this._actions[actionName] = actionInstance;
      }
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'has',


    /**
     * @param {String} actionName
     * @returns {boolean}
     */
    value: function has(actionName) {
      return this.actions.hasOwnProperty(actionName);
    }

    /**
     * @param {String} actionName
     * @returns {Action}
     */

  }, {
    key: 'action',
    value: function action(actionName) {
      if (!this.has(actionName)) {
        throw new _MissingActionException.MissingActionException(this.name, actionName);
      }

      var action = this.actions[actionName];

      action.baseUrl = this._baseUrl;

      return action;
    }

    /**
     * @param {String} actionName
     * @param {*} args
     * @returns {Action}
     */

  }, {
    key: 'request',
    value: function request(actionName) {
      var _action;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_action = this.action(actionName)).request.apply(_action, args);
    }
  }, {
    key: 'baseUrl',
    set: function set(url) {
      this._baseUrl = url;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'actionsConfig',
    get: function get() {
      let config = {};

      for (let actionName in this.actions) {
        if (!this.actions.hasOwnProperty(actionName)) {
          continue;
        }

        let action = this.actions[actionName];

        config[action.sourceId] = {
          resource: this._name,
          name: action.name,
          type: action.type,
          methods: action.methods,
          source: action.source,
          region: action.region,
          forceUserIdentity: action.forceUserIdentity,
          validationSchema: action.validationSchemaName
        };
      }

      return config;
    }
  }, {
    key: 'microservice',
    get: function get() {
      return this._microservice;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'validation',
    get: function get() {
      return this._validation;
    }

    /**
     * @param {Object} validation
     */
    ,
    set: function set(validation) {
      this._validation = validation;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'security',
    get: function get() {
      return this._security;
    }

    /**
     * @param {Object} security
     */
    ,
    set: function set(security) {
      this._security = security;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'name',
    get: function get() {
      return this._name;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'cache',
    get: function get() {
      return this._cache;
    }

    /**
     * @param {Object} cache
     */
    ,
    set: function set(cache) {
      this._cache = cache;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'log',
    get: function get() {
      return this._log;
    }

    /**
     * @param {Object} log
     */
    ,
    set: function set(log) {
      this._log = log;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'localBackend',
    get: function get() {
      return this._localBackend;
    }

    /**
     * @param {Boolean} state
     */
    ,
    set: function set(state) {
      this._localBackend = state;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'isBackend',
    get: function get() {
      return this._isBackend;
    }

    /**
     * @param {Boolean} state
     */
    ,
    set: function set(state) {
      this._isBackend = state;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'actions',
    get: function get() {
      return this._actions;
    }

    /**
     * @param {ContextProvider} contextProvider
     */

  }, {
    key: 'contextProvider',
    set: function set(contextProvider) {
      this._contextProvider = contextProvider;
    }

    /**
     * @returns {ContextProvider}
     */
    ,
    get: function get() {
      return this._contextProvider;
    }
  }]);

  return Instance;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Instance.js
// module id = 427
// module chunks = 0